import React from 'react';

export const Fragment = (componentProps) => {
  return (
    <React.Fragment>
      {componentProps.children}
    </React.Fragment>
  );
};
